import HangingProtocolService from './HangingProtocolService';

export default HangingProtocolService;
